<template>
    <section class="row-12">
        <div class="col-6 col-sm-12 col-md-7 calendar m-r-5">
            <h3 class="m-b-5">Kalendarz</h3>
            <div id='calendar'></div>
        </div>
        <div id="calendar-table" class="col-6 col-sm-12 col-md-5">
            <div id="datemodal" class="modal" style="max-width: 400px;">
                <div class="modal-header">Dodaj wydarzenie</div>
                <div class="modal-body">
                    <form>
                        <input v-model="eventTitle" placeholder="Tytuł"/>
                        <input id="startDatePicker" placeholder="Data rozpoczęcia"/>
                        <input id="endDatePicker" placeholder="Data końcowa"/>
                        <h6 style="margin-top: 10px;">Kolor wydarzenia</h6>
                        <div class="events-colors w-100">
                            <span class="blue"></span>
                            <span class="orange"></span>
                            <span class="red"></span>
                            <span class="green"></span>
                            <span class="gray"></span>
                        </div>
                    </form>
                </div>
                <div class="modal-action flex-align-right">
                    <button class="button-free-p" @click="hideModal('#datemodal')">Anuluj</button>
                    <button @click="addNewEvent()">Dodaj nowe</button>
                </div>
            </div>
            <div id="updatemodal" class="modal" style="max-width: 400px;">
                <div class="modal-header">Aktualizuj wydarzenie</div>
                <div class="modal-body">
                    <form>
                        <input v-model="eventTitle" placeholder="Tytuł"/>
                        <input id="updateStartDatePicker" placeholder="Data rozpoczęcia"/>
                        <input id="updateEndDatePicker" placeholder="Data końcowa"/>
                        <div class="events-colors w-100">
                            <span class="blue"></span>
                            <span class="orange"></span>
                            <span class="red"></span>
                            <span class="green"></span>
                            <span class="gray"></span>
                        </div>
                    </form>
                </div>
                <div class="modal-action flex-align-right">
                    <button class="button-free-p" @click="hideModal('#updatemodal')">Anuluj</button>
                    <button @click="updateEvent()">Aktualizuj</button>
                </div>
            </div>
            <div class="row-12">
                <h3 class="col-7">Wydarzenia</h3>
                <button class="col-5" @click="showModal('#datemodal')">Dodaj nowe</button>
            </div>
            <div v-if="!isDeletingNow">
                <table v-if="filteredEvents.length > 0" class="table-header">
                    <thead>
                    <tr>
                        <th>Wydarzenie</th>
                        <th>Edytuj</th>
                        <th>Usuń</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="table-content" v-for="event in filteredEvents">
                        <td>
                            <small class="text-second-l ">{{event.start}} - {{event.end}}</small>
                            </br>{{event.title}}
                        </td>
                        <td><i @click="modifyEvent(event.id)" class="icons i-default i-settings center-flex-a"></i></td>
                        <td><i @click="deleteEvent(event.id)" class="center-flex-a icons i-default i-cross"></i></td>
                    </tr>
                    </tbody>
                </table>
                <div v-else>
                    <hr>
                    <h3 class="w-100 text-a-c text-third-d">Nie posiadasz żadnych wydarzeń w tym okresie</h3>
                </div>
            </div>
            <div v-else>
                <div class="searchLoader">
                    <div class="span">
                        <div class="help"></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

    export default {
        data: () => {
            return (
                {
                    calendarEvents: [],
                    filteredEvents: [],
                    numberOfAllEventsInMonth: [],
                    eventTitle: '',
                    editedId: 0,
                    eventarr: [],
                    rowWidth: 0,
                    isDeletingNow: false,
                    colorEvent: '',
                }
            );
        },
        methods: {
            countEvents(){
                let tmp, allYears = {};


                this.calendarEvents.filter((value) => {
                   if (tmp !== moment(value.start).format('YYYY'))
                   {
                       tmp = moment(value.start).format('YYYY');
                       allYears[tmp] = [0,0,0,0,0,0,0,0,0,0,0,0];
                   }
                });

                this.calendarEvents.filter((value) => {
                    allYears[moment(value.start).format('YYYY')][moment(value.start).format('M') - 1] += 1;
                });

                return allYears;
            },
            deleteEvent(id) {
                this.isDeletingNow = true;
                axios.delete(`events/${id}`)
                    .then((response) => {
                        notify.createNotifier("Wydarzenie usunięte", "success", 4000);

                        this.calendarEvents = this.calendarEvents.filter((value) => {
                            if (!value.id !== id) {
                                let yStart = moment(value.start).format('YYYY');
                                let yEnd = moment(value.end).format('YYYY');

                                let mStart = parseInt(moment(value.start).format('M')) - 1;
                                let mEnd = parseInt(moment(value.end).format('M')) - 1;

                                this.numberOfAllEventsInMonth[yStart][mStart]--;
                                if (mStart !== mEnd) this.numberOfAllEventsInMonth[yStart][mEnd]--;
                            }
                            return value.id !== id;
                        });

                        this.isDeletingNow = false;
                        this.filterEvents();

                        $('#calendar').fullCalendar('removeEvents');
                        $('#calendar').fullCalendar('addEventSource', this.calendarEvents);
                        $('#calendar').fullCalendar('prev');
                        $('#calendar').fullCalendar('next');

                        this.countEvents();
                    });

            },
            updateEvent() {
                try {
                    new Validator({
                        "kolor": $('.events-colors span.active').length,
                        "poczatek": $('#updateStartDatePicker').val(),
                        "koniec": $('#updateEndDatePicker').val(),
                        "tytul": this.eventTitle
                    })
                        .get("tytul").isNotNull()
                        .get("poczatek").isNotNull()
                        .get("koniec").isNotNull()
                        .get("kolor").isNotNull();
                }
                catch (err) {
                    return false;
                }

                let eventColor = this.hexc($('.events-colors span.active').css('backgroundColor'));
                let updateEvent = {
                    title: this.eventTitle,
                    start: moment($('#updateStartDatePicker').val(), "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss"),
                    end: moment($('#updateEndDatePicker').val(), "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss"),
                    color: eventColor
                };

                if (updateEvent.start > updateEvent.end) {
                    notify.createNotifier('Data rozpoczęcia nie może być później niż data zakończenia', 'danger');
                } else {
                    axios.put(`events/${this.editedId}`, {
                        title: updateEvent.title,
                        start: updateEvent.start,
                        end: updateEvent.end,
                        color: updateEvent.color,
                    })
                        .then((response) => {
                            notify.createNotifier("Wydarzenie zmodyfikowane", "success", 4000);
                            this.hideModal('#updatemodal');

                            this.calendarEvents.map(event => {
                                if (event.id === this.editedId) {
                                    event.title = updateEvent.title;
                                    event.start = updateEvent.start;
                                    event.end = updateEvent.end;
                                    event.color = updateEvent.color;
                                }
                            });

                            this.filterEvents();

                            $('#calendar').fullCalendar('removeEvents');
                            $('#calendar').fullCalendar('addEventSource', this.calendarEvents);
                            $('#calendar').fullCalendar('prev');
                            $('#calendar').fullCalendar('next');

                            $('#updateStartDatePicker').val("");
                            $('#updateEndDatePicker').val("");
                            this.eventTitle = '';
                            $('.events-colors span').removeClass('active');

                        });
                }
            },
            modifyEvent(id) {
                let self = this;
                this.editedId = id;
                let modal = $('#calendar-table #updatemodal');
                let editEvent = this.calendarEvents.filter(event => {
                    return event.id === id
                });
                this.eventTitle = editEvent[0].title;
                this.colorEvent = editEvent[0].color;
                $('#updateStartDatePicker').val(moment(editEvent[0].start).format("YYYY/MM/DD HH:mm"));
                $('#updateEndDatePicker').val(moment(editEvent[0].end).format("YYYY/MM/DD HH:mm"));
                $('#calendar-table #updatemodal .events-colors span').filter(function () {
                    return (self.hexc($(this).css('background-color')) === self.colorEvent);
                }).addClass('active');
                this.showModal(modal);
            },
            addNewEvent() {
                let self = this;
                try {
                    new Validator({
                        "kolor": $('.events-colors span.active').length,
                        "poczatek": $('#startDatePicker').val(),
                        "koniec": $('#endDatePicker').val(),
                        "tytul": this.eventTitle
                    })
                        .get("tytul").isNotNull()
                        .get("poczatek").isNotNull()
                        .get("koniec").isNotNull()
                        .get("kolor").isNotNull();

                    const startDate = moment($('#startDatePicker').val());
                    const endDate = moment($('#endDatePicker').val());

                    if(endDate.isBefore(startDate)){
                        notify.createNotifier("Czas rozpoczęcia nie może być później niż czas zakończenia","danger",4000);
                        throw "Czas rozpoczęcia nie może być później niż czas zakończenia";
                    }

                    if(startDate.isSame(endDate)){
                        notify.createNotifier("Czas rozpoczęcia nie może być taki sam jak czas zakończenia","danger",4000);
                        throw "Czas rozpoczęcia nie może być taki sam jak czas zakończenia";
                    }
                }
                catch (err) {
                    return false;
                }

                let eventColor = this.hexc($('.events-colors span.active').css('backgroundColor'));
                let newEvent = {
                    title: this.eventTitle,
                    start: moment($('#startDatePicker').val(), "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm"),
                    end: moment($('#endDatePicker').val(), "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm"),
                    color: eventColor
                };

                if (newEvent.start > newEvent.end) {
                    notify.createNotifier('Zła data rozpoczęcia lub końca.', 'danger');
                } else {
                    axios.post('events', newEvent)
                        .then((respond) => {

                            notify.createNotifier('Nowe wydarzenie zostało dodane', 'success');

                            newEvent.id = respond.data;
                            newEvent.login_token = null;
                            self.calendarEvents.push($.extend({}, newEvent));

                            let yStart = moment(newEvent.start).format('YYYY');
                            let yEnd = moment(newEvent.end).format('YYYY');

                            let mStart = parseInt(moment(newEvent.start).format('M')) - 1;
                            let mEnd = parseInt(moment(newEvent.end).format('M')) - 1;

                            if (typeof self.numberOfAllEventsInMonth[yStart] === "undefined") {
                                self.numberOfAllEventsInMonth[yStart] = [];
                            }

                            self.numberOfAllEventsInMonth[yStart][mStart]++;
                            if (mStart !== mEnd) self.numberOfAllEventsInMonth[yStart][mEnd]++;

                            self.filterEvents();

                            $('#calendar').fullCalendar('removeEvents');
                            $('#calendar').fullCalendar('addEventSource', self.calendarEvents);
                            $('#calendar').fullCalendar('prev');
                            $('#calendar').fullCalendar('next');

                            $('#startDatePicker').val("");
                            $('#endDatePicker').val("");
                            this.eventTitle = '';
                            $('.events-colors span').removeClass('active');
                            self.hideModal('#datemodal');
                        });
                }
            },
            hexc(colorval) {
                let parts = colorval.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
                delete(parts[0]);
                for (let i = 1; i <= 3; ++i) {
                    parts[i] = parseInt(parts[i]).toString(16);
                    if (parts[i].length === 1) parts[i] = '0' + parts[i];
                }
                return '#' + parts.join('');
            },
            changeDayNames() {
                $('#calendar').fullCalendar('option', {
                    dayNames: ['n', 'p', 'w', 'ś', 'c', 'p', 's'],
                })
            },
            filterEvents(date = moment()) {
                if ($('#calendar .fc-view-container').children().hasClass('fc-month-view')) {
                    let monthTitle = $('.fc-left h2').text();
                    monthTitle = monthTitle.split(' ');
                    this.filterEventsMonth(moment().month(monthTitle[0]).format("M"), date);
                }

                if ($('#calendar .fc-view-container').children().hasClass('fc-agendaWeek-view')) {
                    this.filterEventsWeek();
                }

                if ($('#calendar .fc-view-container').children().hasClass('fc-agendaDay-view')) {
                    this.filterEventsDay();
                }

                if ($('#calendar .fc-view-container').children().hasClass('fc-myYear-view')) {
                    let year = $('.fc-left h2').text();
                    this.filterYearEvents(year);
                }
            },

            filterYearEvents(year) {
                this.filteredEvents = [];

                for (let i = 0; i < this.calendarEvents.length; i++) {
                    if (year === moment(this.calendarEvents[i].start).format('YYYY') || year === moment(this.calendarEvents[i].end).format('YYYY')) {
                        let {title, start, end, id, color} = this.calendarEvents[i];
                        this.filteredEvents.push({
                            title,
                            start: moment(start).format("lll"),
                            end: moment(end).format("lll"),
                            id,
                            color,
                        });
                    }
                }
            },

            filterEventsMonth(month, date) {
                if (typeof date === 'undefined'){
                    date = moment($('#calendar').fullCalendar('getDate'));
                }

                date.month(month - 1);

                this.filteredEvents = [];
                if(this.calendarEvents) {
                    for (let i = 0; i < this.calendarEvents.length; i++) {
                        if (date.isBetween(moment(this.calendarEvents[i].start), moment(this.calendarEvents[i].end), 'month', '[]')) {
                                let {title, start, end, id, color} = this.calendarEvents[i];
                                this.filteredEvents.push({
                                    title,
                                    start: moment(start).format("lll"),
                                    end: moment(end).format("lll"),
                                    id,
                                    color,
                                });
                        }
                    }
                }
            },

            filterEventsWeek() {
                this.filteredEvents = null;
                this.filteredEvents = [];

                let date = moment($('#calendar').fullCalendar('getDate'));
                let dateWeek = date.format('w');

                for (let i = 0; i < this.calendarEvents.length; i++) {


                    let weekStart = moment(this.calendarEvents[i].start).format('w');
                    let weekEnd = moment(this.calendarEvents[i].end).format('w');

                    if (date.format('YYYY') === moment(this.calendarEvents[i].start).format('YYYY') || date.format('YYYY') === moment(this.calendarEvents[i].end).format('YYYY') ) {
                        if (dateWeek >= weekStart && dateWeek <= weekEnd) {
                            let {title, start, end, id, color} = this.calendarEvents[i];
                            this.filteredEvents.push({
                                title,
                                start: moment(start).format("lll"),
                                end: moment(end).format("lll"),
                                id,
                                color,
                            });
                        }
                    }
                }
            },
            filterEventsDay() {
                this.filteredEvents = [];

                let date = moment($('#calendar').fullCalendar('getDate'));
                let dateDay = date.format('D');
                let dateMonth = date.format('M');

                for (let i = 0; i < this.calendarEvents.length; i++) {

                    if (dateMonth === moment(this.calendarEvents[i].start).format('M') || dateMonth === moment(this.calendarEvents[i].end).format('M')) {
                        let dayStart = moment(this.calendarEvents[i].start).format('D');
                        let dayEnd = moment(this.calendarEvents[i].end).format('D');

                        if (dateDay >= dayStart && dateDay <= dayEnd) {
                            let {title, start, end, id, color} = this.calendarEvents[i];
                            this.filteredEvents.push({
                                title,
                                start: moment(start).format("lll"),
                                end: moment(end).format("lll"),
                                id,
                                color
                            });
                        }
                    }
                }
            }
        },
        mounted: function () {
            const self = this;

            axios.get(`events`)
                .then((response) => {
                    self.calendarEvents = response.data;
                    self.numberOfAllEventsInMonth = self.countEvents();

                    $(document).off('click', '.events-colors span');
                    $(document).on('click', '.events-colors span', function () {
                        $('.events-colors span').removeClass('active');
                        $(this).addClass('active');
                    });

                    $('#calendar').fullCalendar({
                        height: 'auto',
                        locale: 'pl',
                        selectable: true,
                        // editable: true,
                        header:
                            {
                                left: 'prev, title ,next',
                                center: '',
                                right: 'myYear,month,agendaWeek,agendaDay'
                            },
                        buttonText:
                            {
                                month: 'miesiąc',
                                week: 'tydzień',
                                day: 'dzień',
                            },
                        views: {
                            week: {
                                columnHeaderFormat: 'M/D',
                                // allDaySlot: false,
                            },
                            month: {
                                columnHeaderFormat: 'dddd',
                                timeFormat: 'HH:mm'
                            },
                            myYear: {
                                buttonText: 'rok',
                                type: 'agenda',
                                duration: {year: 1}
                            },
                            day: {
                                allDaySlot: false,
                                slotLabelFormat: "HH:mm",
                                slotDuration: "00:60:01",
                                minTime: "06:00:00",
                            }
                        },
                        formatString: ["YYYY-MM-DD HH:mm"],
                        events: self.calendarEvents,
                        eventColor: '#3498DB',
                        viewRender: (view, element) => {
                            if (!$('#calendar .fc-button-group button').hasClass('underline')) {
                                $('#calendar .fc-button-group .fc-month-button').addClass('underline');
                            }

                            if (element.hasClass('fc-myYear-view')) {
                                element.html('');

                                $('#calendar .fc-button-group .fc-month-button').removeClass('underline');

                                let date = moment($('#calendar').fullCalendar('getDate'));
                                let currYear = date.format("YYYY");

                                this.numberOfAllEventsInMonth = this.countEvents();

                                if (typeof this.numberOfAllEventsInMonth[currYear] === "undefined") {
                                    this.numberOfAllEventsInMonth[currYear] = [0,0,0,0,0,0,0,0,0,0,0,0];
                                }

                                const newTable = `
                            <table class="year-view">
                                <tr>
                                    <td data-month="1">Styczeń <small>${this.numberOfAllEventsInMonth[currYear][0]}</small></td>
                                    <td data-month="2">Luty <small>${this.numberOfAllEventsInMonth[currYear][1]}</small></td>
                                    <td data-month="3">Marzec <small>${this.numberOfAllEventsInMonth[currYear][2]}</small></td>
                                    <td data-month="4">Kwiecień <small>${this.numberOfAllEventsInMonth[currYear][3]}</small></td>
                                </tr>
                                <tr>
                                    <td data-month="5">Maj <small>${this.numberOfAllEventsInMonth[currYear][4]}</small></td>
                                    <td data-month="6">Czerwiec <small>${this.numberOfAllEventsInMonth[currYear][5]}</small></td>
                                    <td data-month="7">Lipiec <small>${this.numberOfAllEventsInMonth[currYear][6]}</small></td>
                                    <td data-month="8">Sierpień <small>${this.numberOfAllEventsInMonth[currYear][7]}</small></td>
                                </tr>
                                <tr>
                                    <td data-month="9">Wrzesień <small>${this.numberOfAllEventsInMonth[currYear][8]}</small></td>
                                    <td data-month="10">Październik <small>${this.numberOfAllEventsInMonth[currYear][9]}</small></td>
                                    <td data-month="11">Listopad <small>${this.numberOfAllEventsInMonth[currYear][10]}</small></td>
                                    <td data-month="12">Grudzień <small>${this.numberOfAllEventsInMonth[currYear][11]}</small></td>
                                </tr>
                            </table>
                          `;

                                element.append(newTable);
                                $(document).off('click', '.year-view td');
                                $(document).on('click', '.year-view td', function () {
                                    $('.year-view td').each((key, el) => {
                                        $(el).removeClass('actived');
                                    });
                                    $(this).addClass('actived');
                                    $('#calendar').fullCalendar('changeView', 'month', moment(`${currYear}-${$(this).attr('data-month')}-01`));
                                    $('#calendar .fc-button-group button').removeClass('underline');
                                    $('#calendar .fc-button-group button.fc-month-button').addClass('underline');
                                    self.filterEvents();
                                });
                            }

                            if (element.hasClass('fc-agendaWeek-view')) {
                                element.html('');

                                const newTable = `
                                <section id="week-events">
                                    <table class="week-view">
                                      <thead>
                                          <tr>
                                              <th>
                                                  <span>p</span>
                                              </th>
                                              <th>
                                                  <span>w</span>
                                              </th>
                                              <th>
                                                  <span>ś</span>
                                              </th>
                                              <th>
                                                  <span>c</span>
                                              </th>
                                              <th>
                                                  <span>p</span>
                                              </th>
                                              <th>
                                                  <span>s</span>
                                              </th>
                                              <th>
                                                  <span>n</span>
                                              </th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                          </tr>
                                      </tbody>
                                  </table>
                                </section>

                              `;
                                element.append(newTable);
                            }

                        },
                        eventAfterRender: (event) => {
                            $('#week-events').children('div').remove();
                            $(document).off('click', '.fc-prev-button');
                            $(document).on('click', '.fc-prev-button', function () {
                                self.eventarr = [];
                                self.rowWidth = 0;
                                self.filterEvents();
                            });

                            $(document).off('click', '.fc-next-button');
                            $(document).on('click', '.fc-next-button', function () {
                                self.eventarr = [];
                                self.rowWidth = 0;
                                self.filterEvents();
                            });

                            $(document).off('click', '.fc-agendaWeek-button');
                            $(document).on('click', '.fc-agendaWeek-button', function () {
                                self.eventarr = [];
                                self.rowWidth = 0;
                                self.filterEvents();
                            });

                            $(document).off('click', '.fc-month-button');
                            $(document).on('click', '.fc-month-button', function () {
                                self.eventarr = [];
                                self.rowWidth = 0;
                                self.filterEvents();
                            });

                            $(document).off('click', '.fc-agendaDay-button');
                            $(document).on('click', '.fc-agendaDay-button', function () {
                                self.eventarr = [];
                                self.rowWidth = 0;
                                self.filterEvents();
                            });

                            $(document).off('click', '.fc-myYear-button');
                            $(document).on('click', '.fc-myYear-button', function () {
                                $(this).addClass('fc-state-active');
                                self.eventarr = [];
                                self.rowWidth = 0;
                                self.filterEvents();
                            });

                            if ($('#calendar .fc-view-container').children().hasClass('fc-agendaWeek-view')) {

                                self.rowWidth = (100.0 / 7).toFixed(2);

                                self.filterEvents();
                                self.filteredEvents.forEach(function (element, i) {
                                    let start = 0, end = 0;
                                    self.calendarEvents.map((event) => {
                                        if (event.id === element.id) {
                                            start = moment(event.start);
                                            end = moment(event.end);
                                        }
                                    });

                                    if (!end) {
                                        end = start;
                                    }

                                    const startHour = start.format('LT');
                                    const endHour = end.format('LT');
                                    let startDate = 0;
                                    let endDate = 0;

                                    let oneDay = `<small style="font-size: 11px;">${startHour} - ${endHour}</small></br>`;


                                    if (!start.isSame(end, 'day', '[]')) {
                                        startDate = start.format('DD');
                                        endDate = end.format('DD MMM');

                                        oneDay = `<small>${startDate} - ${endDate}</small></br>`;
                                    }

                                    const desc = `
                                <div class="event-content">
                                    <div>
                                        ${oneDay}
                                        <small>${element.title}</small>
                                    </div>
                                </div>`;

                                    $('#week-events').append(desc);
                                    $('.event-content:last-child').css('background-color', element.color);

                                    startDate = start;
                                    endDate = end;

                                    let date = $('#calendar').fullCalendar('getDate');
                                    let dateStart = moment(date).startOf('week');
                                    let dateEnd = moment(date).endOf('week');

                                    let offsetLeft = startDate.isBefore(dateStart) ? 0 : Math.abs(dateStart.diff(startDate, 'days'));
                                    let offsetRight = endDate.isAfter(dateEnd) ? 0 : Math.abs(dateEnd.diff(endDate, 'days'));

                                    $('.event-content:last-child').css('margin-left', offsetLeft * self.rowWidth + "%");
                                    $('.event-content:last-child').css('margin-right', offsetRight * self.rowWidth + "%");
                                });

                            }
                        },
                        dayClick: function (date) {
                        },
                        select: function (startDate, endDate) {
                        }
                    });

                    self.filterEvents();

                    self.changeDayNames();

                    let calendar = $('#calendar').fullCalendar('getCalendar');
                    calendar.off('dayClick');
                    calendar.on('dayClick', function (date, jsEvent, view) {
                        $('#startDatePicker').val(date.format('YYYY/MM/DD HH:mm'));
                        self.filterEvents(date);
                        self.showModal('#datemodal');
                    });

                    calendar.off('select');
                    calendar.on('select', function (startDate, endDate) {
                        $('#startDatePicker').val(startDate.format('YYYY/MM/DD HH:mm'));
                        $('#endDatePicker').val(endDate.format('YYYY/MM/DD HH:mm'));
                        self.showModal('#datemodal');
                    });

                    $(window).resize(function () {
                        self.changeDayNames();
                    });

                    $('#startDatePicker').off('change');
                    $('#endDatePicker').off('change');
                    $('#updateStartDatePicker').off('change');
                    $('#updateEndDatePicker').off('change');

                    jQuery.datetimepicker.setLocale('pl');

                    $('#startDatePicker').datetimepicker({
                        autoclose: true,
                    });

                    $('#endDatePicker').datetimepicker({
                        autoclose: true,
                    });

                    $('#updateStartDatePicker').datetimepicker({
                        autoclose: true,
                    });

                    $('#updateEndDatePicker').datetimepicker({
                        autoclose: true,
                    });


                });

            $(document).off('click', '#calendar .fc-button-group button');
            $(document).on('click', '#calendar .fc-button-group button', function () {
                $('#calendar .fc-button-group button').removeClass('underline');
                $(this).addClass('underline');
            });
        }

    }
</script>


<style lang="scss">

    .event-content {
        background: #333743;
        color: white;
        padding: 5px;
        margin-top: 2px;
        margin-bottom: 2px;
    }

    .events-colors {
        align-items: center;
        span.active {
            border: 2px solid #6e52a8;
        }
    }

    #calendar-table .table-content i:hover {
        cursor: pointer;
    }

    #calendar-table thead tr th:not(:first-child) {
        text-align: center;
    }

    #week-events {
        position: relative;
        width: 100%;
        min-height: 100px;
        display: flex;
        flex-direction: column;
        align-self: stretch;
        align-items: stretch;
        margin-top: 43px;
    }

    .week-view {
        position: absolute;
        top: -27px;
        display: flex;
        align-self: stretch;
        align-items: stretch;
        width: 100%;
        height: 100%;
        flex-wrap: wrap;
        small {
            font-size: 14px;
        }
        thead {
            display: table;
            width: 100%;
            th {
                width: 14.28%;
            }
        }
        tbody {
            height: 100%;
            min-height: 100px;
            width: 100%;
            display: table;
            tr {
                height: 100%;
                td {
                    border-color: rgba(52, 55, 67, 0.2);
                    height: 100%;
                    .event-content {
                        width: 90%;
                        margin: auto;
                        height: 50px;
                        margin-top: 5px;
                        background-color: #34495e;
                        border-radius: 5px;
                        color: white;
                        div {
                            display: flex;
                            flex-direction: column;
                            font-size: 14px;
                            padding: 3px;
                        }
                    }
                }
            }
        }

        th {
            padding: 0 0 10px;
        }
    }

    .year-view {
        tr {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
        }

        td.actived {
            color: white;
            background: #343743;
            &:hover {
                color: white;
                background: #343743;
            }
        }

        td {
            width: calc(25% - 32px);
            display: flex;
            flex-direction: column;
            padding: 15px;
            border-color: rgba(52, 55, 67, 0.05) !important;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            @media(max-width: 1000px) {
                width: calc(50% - 32px);
            }

            small {
                margin-top: 5px;
                padding: 5px;
                line-height: 12px;
                height: 12px;
                min-width: 12px;
                text-align: center;
                border-radius: 50%;
                color: white;
                background-color: #6E53A8;
            }

            transition: all .3s;
            &:hover {
                background-color: #e5e5e5;
            }
        }
    }
</style>
